import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	dismiss(evt) {
		evt.preventDefault();
		this.element.remove();
	}
}
